import { Currency } from '../types';

const splitCurrencyPair = (currencyPair: string): [Currency, Currency] => {
  const sourceCurrencyPart = currencyPair.slice(0, 3) as Currency;
  const targetCurrencyPart = currencyPair.slice(3, 6) as Currency;
  return [sourceCurrencyPart, targetCurrencyPart];
};

type GetCorrectExchangeRateParams = {
  currencyPair: string;
  exchangeRate: number;
  sourceCurrency: string;
};

/**
 * In case we get the wrong currency pair we flip the exchange rate.
 *
 * Example: intended source: HUF intended target: EUR.
 *
 * The backend flips it, and returns the EUR -> HUF exchangeRate with "EUREUR" as currencyPair.
 * We need to flip it, again, if we want to use the currency pair we requested.
 */
export const getCorrectExchangeRate = ({
  currencyPair,
  exchangeRate,
  sourceCurrency,
}: GetCorrectExchangeRateParams): number => {
  const [sourceCurrencyPart, targetCurrencyPart] = splitCurrencyPair(currencyPair);
  if (sourceCurrency === sourceCurrencyPart && sourceCurrency === targetCurrencyPart) {
    return 1 / exchangeRate;
  }

  return exchangeRate;
};

type GetDominantCurrencyParams = {
  currencyPair: string;
  sourceCurrency: string;
  targetCurrency: string;
};

export const getDominantCurrency = ({
  currencyPair,
  sourceCurrency,
  targetCurrency,
}: GetDominantCurrencyParams): string => {
  const [, targetCurrencyPart] = splitCurrencyPair(currencyPair);

  if (targetCurrencyPart === sourceCurrency || targetCurrencyPart === targetCurrency) {
    return targetCurrencyPart;
  }

  throw new Error(`Unexpected currency pair: "${currencyPair}"!`);
};
